import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { IProduct } from 'reactApp/modules/products/products.types';
import { Product } from 'reactApp/types/Billing';
import { ACTIONS_DEFS, ETabsName } from 'reactApp/ui/TariffsSection/TariffSection.constants';
import { getDiscount } from 'reactApp/utils/getDiscount';
import { getMonthes, isMonthPeriod, isYear2Period, isYearPeriod } from 'reactApp/utils/Period';

import { TABS_MAP } from './MobileSubscriptionsPage.constants';
import { ITariffsMobile, TabValue } from './MobileSubscriptionsPage.types';

export const getActiveTab = (hash: string) => {
    const tabs = Object.fromEntries(Object.entries(TABS_MAP).map(([k, v]) => [v, k as TabValue]));
    return tabs[hash] || tabs[TABS_MAP.special];
};

export const getAvailableHash = (hash: string, marketingPromo?: typeof ACTIONS_DEFS['marketingPromo']) => {
    if (hash) {
        return hash;
    }

    return marketingPromo ? TABS_MAP.special : TABS_MAP.usual;
};

export const normalizeMobileTariffList = (
    productsBySpace: Record<number, [Product, Product | undefined] | [Product, Product | undefined, Product | undefined]>,
    isMarketingPromo?: boolean,
    activeTariffPeriod?: ETabsName
): ITariffsMobile[] => {
    return Object.entries(productsBySpace).map(([bytes, product]) => {
        const space = bytesToNDigits(Number(bytes), 3);
        const quota = space.space;
        const countSnapshotsBySpace = Math.round(Number(bytes) / (3.5 * 1024 * 1024));
        const monthProduct = product.find((p) => p?.period && isMonthPeriod(p.period));
        const yearProduct = product.find((p) => p?.period && isYearPeriod(p.period));
        const twoYearProduct = product.find((p) => p?.period && isYear2Period(p.period));
        const hasOldPriceYear = Boolean(yearProduct?.discountPrice);
        let saving;
        if (monthProduct && yearProduct && yearProduct?.discountPrice && isMarketingPromo) {
            const yearPriceByMonth = getMonthes(yearProduct.period) * monthProduct.price;
            const { discount } = getDiscount({
                discountPrice: yearProduct.discountPrice,
                price: yearPriceByMonth,
            });

            saving = discount;
        } else if (yearProduct && yearProduct?.discountPrice) {
            saving = Math.round(((yearProduct?.price - yearProduct.discountPrice) / yearProduct?.price) * 100);
        } else if (yearProduct && monthProduct) {
            saving = Math.round((1 - yearProduct.price / (getMonthes(yearProduct.period) * monthProduct.price)) * 100);
        }

        // tempexp_15246-start
        let activeProduct;

        if (activeTariffPeriod === ETabsName.year && yearProduct) {
            activeProduct = yearProduct;
        }

        if (activeTariffPeriod === ETabsName.twoYears && twoYearProduct) {
            activeProduct = twoYearProduct;
        }

        if (activeTariffPeriod === ETabsName.month && monthProduct) {
            activeProduct = monthProduct;
        }

        let yearDiscount;

        if (activeProduct && (activeTariffPeriod === ETabsName.twoYears || activeTariffPeriod === ETabsName.year) && monthProduct) {
            const yearPriceByMonth = getMonthes(activeProduct.period) * monthProduct.price;
            const { discount } = getDiscount({
                discountPrice: activeProduct.price,
                price: yearPriceByMonth,
            });

            yearDiscount = discount;
        }

        const products = activeProduct
            ? [{ primary: true, saving: yearDiscount, ...activeProduct } as IProduct]
            : [
                  monthProduct,
                  {
                      saving,
                      primary: true,
                      ...yearProduct,
                  },
              ];
        // tempexp_15246-end

        return {
            space,
            oldPrice: yearProduct?.price,
            hasOldPriceYear,
            fullPrice: yearProduct?.price,
            countSnapshotsBySpace,
            tariffTypeLabel: isMarketingPromo && quota === 256 ? 'Выгодно' : '',
            showPriceByMonth: isMarketingPromo,
            isBase: product.some((p) => p?.isBase),
            products: (products as IProduct[]).filter(Boolean),
        };
    });
};
